export default __webpack_public_path__ + "/assets/bg-budrio-01.jpg";